import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import DigitalEditContainer from './components/DigitalEditContainer';
import DigitalEditDetailsContainer from './components/DigitalEditDetailsContainer';
import DigitalEditPaymentContainer from './components/DigitalEditPaymentContainer';
import { loadDigitalEditing } from './actions';
export var Routes = function Routes(_ref) {
  var loadDigitalEditing = _ref.loadDigitalEditing;
  useEffect(function () {
    loadDigitalEditing();
  }, []);
  return /*#__PURE__*/React.createElement(RouterRoutes, null, /*#__PURE__*/React.createElement(Route, {
    path: "details/:identity",
    element: /*#__PURE__*/React.createElement(DigitalEditDetailsContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "subscribe/:receiptCode?/:success?",
    element: /*#__PURE__*/React.createElement(DigitalEditPaymentContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":status?",
    element: /*#__PURE__*/React.createElement(DigitalEditContainer, null)
  }));
};
var mapDispatchToProps = {
  loadDigitalEditing: loadDigitalEditing
};
export default connect(null, mapDispatchToProps)(Routes);